// Note: All ReadOnly Flags can be placed in this file
import {Injectable} from '@angular/core';
import {ClaimDisplayDTO} from '../../clm/models/claim/ClaimDisplayDTO';
import {ProcessingStatus} from '../../clm/types/processing-status.enum';

@Injectable({
  providedIn: 'root',
})
export class ReadOnlyService {

  private readonly _readOnlyStages: ProcessingStatus[] = [
    ProcessingStatus.Paid,
    ProcessingStatus.Locked,
    ProcessingStatus.AuthorisationClaimed,
    ProcessingStatus.PaymentRunComplete,
    ProcessingStatus.Reversed,
    ProcessingStatus.UpfrontPaid
  ];
  private _readOnlyTransactions = false;

  get readOnlyTransactions(): boolean {
    return this._readOnlyTransactions;
  }

  get readOnlyStages(): ProcessingStatus[] {
    return this._readOnlyStages;
  }

  set readOnlyTransactions(value: boolean) {
    this._readOnlyTransactions = value;
  }

  public isTransactionReadOnly(processingStatus: ProcessingStatus): boolean {
    return this.readOnlyStages.includes(processingStatus);
  }

}
